@if ((isFocusedStoreAvailable$ | async) === false) {
  <div class="default-pane">
    <mat-icon>list</mat-icon>
    <div class="body-02 default-text">
      Select an object or shape to view its attributes
    </div>
  </div>
} @else if (shouldShowClassSelector$ | async) {
  <h3-class-selector
    h3ScrollEnabler
    (closeClassSelector)="closeClassSelector($event)"
  ></h3-class-selector>
} @else if ((hasValidClass$ | async) === false) {
  <div class="select-class-button-container">
    <button
      mat-stroked-button
      class="select-class-button edit-button"
      [ngClass]="{ 'button-enabled': (isClassReadOnly$ | async) === false }"
      color="primary"
      [disabled]="isClassReadOnly$ | async"
      (click)="openClassSelector('button')"
    >
      <mat-icon
        [svgIcon]="'object'"
        [ngClass]="{
          'object-icon-enabled': (isClassReadOnly$ | async) === false,
        }"
      ></mat-icon
      >select class
    </button>
  </div>
} @else {
  <div class="attribute-section">
    <div class="title-bar">
      <div
        class="title subtitle-03"
        [ngClass]="{ clickable: (isClassReadOnly$ | async) === false }"
        (click)="openClassSelector('class_name')"
      >
        {{ paneTitle$ | async }}
      </div>
    </div>
  </div>
  <h3-tag-pane></h3-tag-pane>
}
